import { render, staticRenderFns } from "./DailiesHeader.vue?vue&type=template&id=1cf1ba12&lang=pug"
import script from "./DailiesHeader.vue?vue&type=script&lang=js"
export * from "./DailiesHeader.vue?vue&type=script&lang=js"
import style0 from "./DailiesHeader.vue?vue&type=style&index=0&id=1cf1ba12&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports